{
    "childReferenceShortName": "Attribute(s)/Filter(s)",
    "parentReferenceShortName": "Used By",
    "deleteAllEntitiesMessage": "The selected attribute(s)/filter(s) are in use by other attribute(s)/filter(s). Proceeding with this action will delete all attribute(s)/filter(s) listed below. Including the attribute(s)/filters(s) listed in the Used By column. Do you wish to proceed?"
}
